import React, { useRef, useCallback } from 'react'

const LEVELS = [
  {
    value: 1,
    label: 'Underloaded',
    subtitle: 'Capacity is going unused',
    iconKey: 'far_left',
    bgTint: '#FCEBEB',
    accentColor: '#E24B4A',
    titleColor: '#791F1F',
    subtitleColor: '#A32D2D',
    needleColor: '#791F1F',
  },
  {
    value: 2,
    label: 'Light',
    subtitle: 'Room for more',
    iconKey: 'mid_left',
    bgTint: '#FAEEDA',
    accentColor: '#BA7517',
    titleColor: '#412402',
    subtitleColor: '#633806',
    needleColor: '#412402',
  },
  {
    value: 3,
    label: 'Just right',
    subtitle: 'Busy but sustainable',
    iconKey: 'center',
    bgTint: '#E1F5EE',
    accentColor: '#1D9E75',
    titleColor: '#04342C',
    subtitleColor: '#0F6E56',
    needleColor: '#04342C',
  },
  {
    value: 4,
    label: 'Heavy',
    subtitle: 'Stretched but holding',
    iconKey: 'mid_right',
    bgTint: '#FAEEDA',
    accentColor: '#BA7517',
    titleColor: '#412402',
    subtitleColor: '#633806',
    needleColor: '#412402',
  },
  {
    value: 5,
    label: 'Overloaded',
    subtitle: 'Something has to give',
    iconKey: 'far_right',
    bgTint: '#FCEBEB',
    accentColor: '#E24B4A',
    titleColor: '#791F1F',
    subtitleColor: '#A32D2D',
    needleColor: '#791F1F',
  },
]

export { LEVELS as WORKLOAD_LEVELS }

function FarLeftIcon({ selected, style }) {
  const strokeW = selected ? 2.5 : 2.0
  return (
    <svg viewBox="0 0 56 44" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M 8 34 A 20 20 0 0 1 48 34" fill="none" stroke="#E24B4A" strokeWidth="5" strokeLinecap="round" opacity={selected ? 1 : 0.35} />
      <path d="M 17 34 A 20 20 0 0 1 39 34" fill="none" stroke="#BA7517" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <path d="M 23 34 A 20 20 0 0 1 33 34" fill="none" stroke="#1D9E75" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <line x1="28" y1="34" x2="12" y2="22" stroke="#791F1F" strokeWidth={strokeW} strokeLinecap="round" />
      <circle cx="28" cy="34" r="2.5" fill="#791F1F" />
    </svg>
  )
}

function MidLeftIcon({ selected, style }) {
  const strokeW = 2.0
  return (
    <svg viewBox="0 0 56 44" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M 8 34 A 20 20 0 0 1 48 34" fill="none" stroke="#E24B4A" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <path d="M 17 34 A 20 20 0 0 1 39 34" fill="none" stroke="#BA7517" strokeWidth="5" strokeLinecap="round" opacity={selected ? 1 : 0.35} />
      <path d="M 23 34 A 20 20 0 0 1 33 34" fill="none" stroke="#1D9E75" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <line x1="28" y1="34" x2="18" y2="17" stroke="#412402" strokeWidth={strokeW} strokeLinecap="round" />
      <circle cx="28" cy="34" r="2.5" fill="#412402" />
    </svg>
  )
}

function CenterIcon({ selected, style }) {
  const strokeW = selected ? 2.8 : 2.2
  const hubR = selected ? 3 : 2.5
  return (
    <svg viewBox="0 0 56 44" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M 8 34 A 20 20 0 0 1 48 34" fill="none" stroke="#E24B4A" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <path d="M 17 34 A 20 20 0 0 1 39 34" fill="none" stroke="#BA7517" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <path d="M 23 34 A 20 20 0 0 1 33 34" fill="none" stroke="#1D9E75" strokeWidth="5" strokeLinecap="round" opacity={selected ? 1 : 0.35} />
      <line x1="28" y1="34" x2="28" y2={selected ? 12 : 14} stroke="#04342C" strokeWidth={strokeW} strokeLinecap="round" />
      <circle cx="28" cy="34" r={hubR} fill="#04342C" />
    </svg>
  )
}

function MidRightIcon({ selected, style }) {
  const strokeW = 2.0
  return (
    <svg viewBox="0 0 56 44" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M 8 34 A 20 20 0 0 1 48 34" fill="none" stroke="#E24B4A" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <path d="M 17 34 A 20 20 0 0 1 39 34" fill="none" stroke="#BA7517" strokeWidth="5" strokeLinecap="round" opacity={selected ? 1 : 0.35} />
      <path d="M 23 34 A 20 20 0 0 1 33 34" fill="none" stroke="#1D9E75" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <line x1="28" y1="34" x2="38" y2="17" stroke="#412402" strokeWidth={strokeW} strokeLinecap="round" />
      <circle cx="28" cy="34" r="2.5" fill="#412402" />
    </svg>
  )
}

function FarRightIcon({ selected, style }) {
  const strokeW = selected ? 2.5 : 2.0
  return (
    <svg viewBox="0 0 56 44" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M 8 34 A 20 20 0 0 1 48 34" fill="none" stroke="#E24B4A" strokeWidth="5" strokeLinecap="round" opacity={selected ? 1 : 0.35} />
      <path d="M 17 34 A 20 20 0 0 1 39 34" fill="none" stroke="#BA7517" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <path d="M 23 34 A 20 20 0 0 1 33 34" fill="none" stroke="#1D9E75" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
      <line x1="28" y1="34" x2="44" y2="22" stroke="#791F1F" strokeWidth={strokeW} strokeLinecap="round" />
      <circle cx="28" cy="34" r="2.5" fill="#791F1F" />
    </svg>
  )
}

function IconFor({ iconKey, selected, style }) {
  const props = { selected, style }
  switch (iconKey) {
    case 'far_left':  return <FarLeftIcon {...props} />
    case 'mid_left':  return <MidLeftIcon {...props} />
    case 'center':    return <CenterIcon {...props} />
    case 'mid_right': return <MidRightIcon {...props} />
    case 'far_right': return <FarRightIcon {...props} />
    default:          return null
  }
}

export function WorkloadGaugeScale({ value, onChange, disabled }) {
  const buttonsRef = useRef([])
  const selected = value?.value ?? null
  const selectedLevel = selected ? LEVELS.find((l) => l.value === selected) : null

  const handleClick = useCallback((level) => {
    if (disabled) return
    onChange({ value: level.value, label: level.label })
  }, [disabled, onChange])

  const handleKeyDown = useCallback((e, index) => {
    if (disabled) return
    let nextIndex = null
    if (e.key === 'ArrowRight') {
      nextIndex = Math.min(index + 1, LEVELS.length - 1)
    } else if (e.key === 'ArrowLeft') {
      nextIndex = Math.max(index - 1, 0)
    } else if (e.key === 'Home') {
      nextIndex = 0
    } else if (e.key === 'End') {
      nextIndex = LEVELS.length - 1
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleClick(LEVELS[index])
      return
    } else {
      return
    }
    e.preventDefault()
    buttonsRef.current[nextIndex]?.focus()
  }, [disabled, handleClick])

  const focusableIndex = selected ? LEVELS.findIndex((l) => l.value === selected) : 0

  return (
    <div style={styles.container}>
      {/* Icon row */}
      <div style={styles.iconRow}>
        {LEVELS.map((level, index) => {
          const isSelected = selected === level.value
          const opacity = disabled ? 0.4 : isSelected ? 1 : 0.55
          return (
            <button
              key={level.value}
              ref={(el) => { buttonsRef.current[index] = el }}
              style={{
                ...styles.iconButton,
                opacity,
                cursor: disabled ? 'default' : 'pointer',
                transition: 'opacity var(--duration-fast) ease',
              }}
              onClick={() => handleClick(level)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onMouseEnter={(e) => {
                if (!disabled && !isSelected) e.currentTarget.style.opacity = '0.8'
              }}
              onMouseLeave={(e) => {
                if (!disabled && !isSelected) e.currentTarget.style.opacity = '0.55'
              }}
              disabled={disabled}
              tabIndex={index === focusableIndex ? 0 : -1}
              aria-label={`Workload level ${level.value}: ${level.label}`}
              aria-pressed={isSelected}
            >
              <IconFor
                iconKey={level.iconKey}
                selected={isSelected}
                style={{ width: '100%', height: '100%', display: 'block' }}
              />
            </button>
          )
        })}
      </div>

      {/* Verdict panel */}
      {selectedLevel && (
        <div
          style={{
            ...styles.verdictPanel,
            background: selectedLevel.bgTint,
          }}
          role="status"
          aria-live="polite"
        >
          <div style={{ ...styles.accentBar, background: selectedLevel.accentColor }} />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: selectedLevel.titleColor }}>
              {selectedLevel.label}
            </div>
            <div style={{ fontSize: 11, color: selectedLevel.subtitleColor }}>
              {selectedLevel.subtitle}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 100,
    padding: '12px 14px',
  },
  iconRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'clamp(4px, 1.5vw, 12px)',
    padding: '0 clamp(2px, 1vw, 8px)',
    width: '100%',
  },
  iconButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    flex: '1 1 0',
    minWidth: 32,
    maxWidth: '20%',
    aspectRatio: '56 / 44',
  },
  verdictPanel: {
    marginTop: 14,
    padding: '10px 14px',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  accentBar: {
    width: 6,
    height: 24,
    borderRadius: 3,
    flexShrink: 0,
  },
}
